    (function () {
        'use strict';

        var module = angular.module('uwAgenda.global');
        module.filter('RfGlobalMonthDateFilter', [RfGlobalMonthDateFilterFn]);

        // month-date filter (month year), uses moment.locale (set on login)
        function RfGlobalMonthDateFilterFn() {
            return function (date) {
                if (date) {
                    var dateMoment = moment(date);
                    return dateMoment.format('MMMM YYYY');
                }
                return date;
            };
        }
    })();